import withLocaleContext from 'hoc/withLocaleContext';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { ExpandElement, TextContainer } from '../Footer.styles';

class BlueMediaCardDataProcessingNote extends PureComponent<Partial<ILocaleContext>, { isOpened: boolean }> {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
    };
  }

  clickHandler = () => {
    this.setState(prevState => ({ isOpened: !prevState.isOpened }));
  };

  render() {
    const { isOpened } = this.state;
    const { formatMessage } = this.props;
    return (
      <div className="data-processing-notice card-data-processing-notice">
        <TextContainer>
          <FormattedMessage id="footer.card.dataProcessing1a" />
          <FormattedMessage id="footer.card.dataProcessing1b" />
          <FormattedMessage id="footer.card.dataProcessing1c" />
          {!isOpened && (
            <ExpandElement onClick={this.clickHandler}>
              <FormattedMessage id="footer.expand" />
            </ExpandElement>
          )}
        </TextContainer>
        {isOpened && (
          <div>
            <TextContainer>
              <FormattedMessage id="footer.card.dataProcessing2" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.card.dataProcessing3" />
              <a
                href={formatMessage && formatMessage({ id: 'footer.card.privacyPolicyLink' })}
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage id="footer.card.privacyPolicyTxt" />
              </a>
              {isOpened && (
                <ExpandElement onClick={this.clickHandler}>
                  <FormattedMessage id="footer.colapse" />
                </ExpandElement>
              )}
            </TextContainer>
          </div>
        )}
      </div>
    );
  }
}

export default withLocaleContext(BlueMediaCardDataProcessingNote);
